/* Capabilities naming*/
const FLEXIBLE_ATTRIBUTES = "flexibleAttributes";

/* Required Capabilities mapping*/
export const capabilitiesMap = {
  UserAttributes: [FLEXIBLE_ATTRIBUTES]
}


// WEBPACK FOOTER //
// ./src/constants/requiredCapabilitiesMapping.js